import {Directive, ElementRef, AfterViewInit, Input, Output, EventEmitter, OnDestroy, inject} from '@angular/core';

@Directive({
  selector: '[appDetectOverflow]',
})
export class DetectOverflowDirective implements AfterViewInit, OnDestroy {
  @Input() text: string = '';
  @Input() font: string = '14px Metropolis';
  @Output() overflowDetected = new EventEmitter<boolean>();

  private resizeObserver!: ResizeObserver;
  private maxChars: number = 0;

  elementRef = inject(ElementRef);

  ngAfterViewInit() {
    this.calculateMaxChars();
    this.checkOverflow();
    this.observeChanges();
  }

  private observeChanges() {
    this.resizeObserver = new ResizeObserver(() => this.checkOverflow());
    this.resizeObserver.observe(this.elementRef.nativeElement);
  }

  private calculateMaxChars() {
    const element = this.elementRef.nativeElement;
    const context = document.createElement('canvas').getContext('2d');
    if (!context) return;

    context.font = this.font;
    let width = element.clientWidth;

    let charWidth = context.measureText('A').width;
    this.maxChars = Math.floor(width / charWidth);
  }

  private checkOverflow() {
    const isOverflowing = this.text.length > this.maxChars;
    this.overflowDetected.emit(isOverflowing);
  }

  ngOnDestroy() {
    this.resizeObserver?.disconnect();
  }
}
